import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ProfileContext } from "../../context/ProfileContext";

const ProfileInfo = ({ showBirthYearField = true }) => {
  const { profile } = useContext(ProfileContext);
  const { t } = useTranslation();

  if (!profile) {
    return (
      <div className="p-6 md:p-7 bg-white rounded-2xl border border-neutral-200 shadow-sm">
        <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: "Georgia, serif" }}>
          {t("profile.info.title")}
        </h2>
        <p className="text-sm text-gray-500">
          {t("profile.info.loading")}
        </p>
      </div>
    );
  }

  return (
    <div className="p-6 md:p-7 bg-white rounded-2xl border border-neutral-200 shadow-sm">
      <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: "Georgia, serif" }}>
        {t("profile.info.title")}
      </h2>
      <div className="space-y-2">
        <p>
          <strong>{t("profile.info.lastName")} :</strong>{" "}
          {profile.last_name}
        </p>
        <p>
          <strong>{t("profile.info.firstName")} :</strong>{" "}
          {profile.first_name}
        </p>
        <p>
          <strong>{t("profile.info.email")} :</strong>{" "}
          {profile.email}
        </p>
        <p>
          <strong>{t("profile.info.company")} :</strong>{" "}
          {profile.company}
        </p>
        {/* ✅ Masquer année de naissance pour Admin/Team */}
        {showBirthYearField && (
          <p>
            <strong>{t("profile.info.birthYear")} :</strong>{" "}
            {profile.birth_year}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProfileInfo;